import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'

export function NextButton({children, ...props}) {
  return (
    <AtomButton
      color={atomButtonColors.PRIMARY}
      design={atomButtonDesigns.SOLID}
      fullWidth
      shape={atomButtonShapes.CIRCULAR}
      size={atomButtonSizes.LARGE}
      {...props}
    >
      {children}
    </AtomButton>
  )
}

NextButton.displayName = 'StepperFlowNextButton'
NextButton.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func.isRequired
}
